import React, { useState } from "react";
import { Grid, TextField, Button, Typography, Box, Link } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import CustomButton from "./CustomButton";
import axios from "../axiosInstance";
import { message } from "antd";
import AdmissionEnquiry from "../assets/AdmissionEnquiry.jpg";

import { InputAdornment } from "@mui/material";
import { Person, Phone, Email, Message } from "@mui/icons-material";

const Enquiry = () => {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // setLoading(true);
    try {
      const response = await axios.post(
        "/api/v1/contact/add-contact",
        formData
      );
      if (response.data.success === true) {
        message.success("Enquiry submitted successfully!");
        setFormData({ name: "", phone: "", email: "", message: "" });
      } else {
        message.error(response.data.message || "Failed to submit enquiry");
      }
    } catch (error) {
      message.error(error.response.data.message || "Failed to submit enquiry.");
    }
  };

  return (
    <Box
      sx={{
        // mt: 8,
        backgroundImage: `url(${AdmissionEnquiry})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        position: "relative",
      }}
    >
      {/* Overlay */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          height: "100%",
          width: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.3)",
          zIndex: 1,
        }}
      />

      {/* Content */}
      <Box sx={{ position: "relative", zIndex: 2, mx: "auto" }}>
        <Grid
          container
          spacing={0}
          sx={{
            backgroundColor: "rgba(255, 255, 255, 0.92)",
            width: "100%",
            maxWidth: "auto",
            mx: "auto",
          }}
        >
          {/* Left - Text Section */}
          <Grid
            item
            xs={12}
            md={6}
            sx={{
              backgroundColor: "rgba(255, 255, 255, 0.2)",
              p: 4,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <Typography
              variant="h5"
              sx={{
                fontFamily: "Montserrat, sans-serif",
                fontOpticalSizing: "auto",
                fontStyle: "normal",
                letterSpacing: 1,
                color: "#065A79",
                fontWeight: "bold",
              }}
            >
              Appointment
            </Typography>
            <Typography
              variant="h4"
              gutterBottom
              sx={{
                mt: 2,
                fontWeight: "bold",
                fontFamily: "Montserrat, sans-serif",
                color: "#AD1C86",
              }}
            >
              Admission Enquiry
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontFamily: "Montserrat, sans-serif",
                fontSize: 16,
                lineHeight: "1.8rem",
                color: "#333",
              }}
            >
              Submit the Enquiry Form and visit the school admissions office.
              Our counsellor will get back to you to answer your questions and
              collect the required information.
            </Typography>

            <Link
              component={RouterLink}
              to="/admission-process"
              underline="hover"
              sx={{
                color: "#065A79",
                display: "inline-block",
                mt: 2,
                fontWeight: 500,
              }}
            >
              READ MORE →
            </Link>
          </Grid>

          <Grid item xs={12} md={6} sx={{ p: 4 }}>
            <TextField
              fullWidth
              label="Full Name"
              name="name"
              placeholder="Please enter your name"
              value={formData.name}
              onChange={handleChange}
              margin="normal"
              InputLabelProps={{
                sx: {
                  color: "#AD1C86",
                  "&.Mui-focused": {
                    color: "#AD1C86",
                    fontWeight: "bold",
                  },
                },
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Person sx={{ color: "#AD1C86" }} />
                  </InputAdornment>
                ),
              }}
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "#AD1C86",
                  },
                  "&:hover fieldset": {
                    borderColor: "#AD1C86",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#065A79",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderRadius: "10px",
                  },
                },
              }}
            />

            <TextField
              fullWidth
              label="Phone"
              name="phone"
              placeholder="Please enter your phone number"
              type="number"
              value={formData.phone}
              onChange={handleChange}
              margin="normal"
              InputLabelProps={{
                sx: {
                  color: "#AD1C86",
                  "&.Mui-focused": {
                    color: "#AD1C86",
                    fontWeight: "bold",
                  },
                },
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Phone sx={{ color: "#AD1C86" }} />
                  </InputAdornment>
                ),
              }}
              
              sx={{
                "& input[type='number']": {
                  MozAppearance: "textfield",
                  "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button":
                    {
                      display: "none",
                    },
                },
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "#AD1C86",
                  },
                  "&:hover fieldset": {
                    borderColor: "#AD1C86",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#065A79",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderRadius: "10px",
                  },
                },
              }}
            />

            <TextField
              fullWidth
              label="Email"
              name="email"
              placeholder="Please enter your email address"
              value={formData.email}
              onChange={handleChange}
              margin="normal"
              InputLabelProps={{
                sx: {
                  color: "#AD1C86",
                  "&.Mui-focused": {
                    color: "#AD1C86",
                    fontWeight: "bold",
                  },
                },
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Email sx={{ color: "#AD1C86" }} />
                  </InputAdornment>
                ),
              }}
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "#AD1C86",
                  },
                  "&:hover fieldset": {
                    borderColor: "#AD1C86",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#065A79",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderRadius: "10px",
                  },
                },
              }}
            />

            <TextField
              fullWidth
              multiline
              rows={3}
              label="Message"
              name="message"
              placeholder="Type your message here..."
              value={formData.message}
              onChange={handleChange}
              margin="normal"
              InputLabelProps={{
                sx: {
                  color: "#AD1C86",
                  "&.Mui-focused": {
                    color: "#AD1C86",
                    fontWeight: "bold",
                  },
                },
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Message sx={{ color: "#AD1C86", mb: 5 }} />
                  </InputAdornment>
                ),
              }}
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "#AD1C86",
                  },
                  "&:hover fieldset": {
                    borderColor: "#AD1C86",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#065A79",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderRadius: "10px",
                  },
                },
              }}
            />

            <Box mt={2}>
              <CustomButton ButtonName={"Submit"} handleSubmit={handleSubmit} />
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default Enquiry;
